// services/dashboard.ts
import { ApiResponse, BASE_URL, getFromServer } from "server";

export interface DashboardStatsOutput {
  totalCount: number;
  statusCount: {
    in_standby: number;
    in_processing: number;
    resolved: number;
    rejected: number;
  };
  dailyStats: Record<string, number>;
}

export interface DashboardStatsInput {
  month: number;
  year: number;
}

// export async function getDashboardStats(
//   input: DashboardStatsInput
// ): Promise<ApiResponse<DashboardStatsOutput>> {
//   const { month, year } = input;
//   const url = `${BASE_URL}/problems/all/stats?month=${month}&year=${year}`;
//   return await getFromServer<DashboardStatsOutput>(url);
// }

// #/problems/all/stats?month=<month>&year=<year>
export async function getDashboardStats(
  input: DashboardStatsInput,
): Promise<ApiResponse<DashboardStatsOutput>> {
  const { month, year } = input;

  // Construction de l'URL avec les paramètres
  const url = `${BASE_URL}/problems/all/stats?month=${month}&year=${year}`;

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      const errorData = await response.json();
      return {
        status: response.status,
        body: {
          message: errorData.message || "Une erreur est survenue",
        } as any,
      };
    }

    const data = await response.json();

    // Vérification de la structure des données
    if (!data || typeof data !== "object") {
      throw new Error("Format de données invalide");
    }

    return {
      status: response.status,
      body: data as DashboardStatsOutput,
    };
  } catch (error) {
    console.error("Erreur lors de la requête:", error);
    return {
      status: 500,
      body: { message: "Erreur lors de la récupération des données" } as any,
    };
  }
}
